import InputMask from 'react-input-mask';

function InputFormMask(props) {
  const {
    id,
    label,
    optional,
    invalid,
    type,
    min,
    max,
    maxLength,
    style,
    disabled,
    placeholder,
    value,
    name,
    pattern,
    onChange,
    onBlur,
    onInput,
    autoComplete,
    required,
    mask,
  } = props;

  const inputClass = `w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 ${invalid ? 'border-red-500 p-invalid' : 'border-gray-300'
    }`;

  return (
    <>
      {label && (
        <label
          htmlFor={id}
          className={`block text-sm font-medium mb-1 ${invalid ? 'text-red-500' : 'text-gray-700'
            }`}
        >
          {label}
          {!optional && <span className="text-red-500"> *</span>}
        </label>
      )}

      {mask ? (
        <InputMask
          mask={mask}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={name}
          disabled={disabled} 
maskChar={null}
alwaysShowMask={false}


        >
          {(inputProps) => (
            <input
              {...inputProps}
              id={id}
              type={type}
              min={min}
              max={max}
              disabled={disabled}
              maxLength={maxLength}
              style={style}
              placeholder={placeholder}
              className={inputClass}
              pattern={pattern}
              autoComplete={autoComplete}
              required={required}
              onInput={onInput}
            />
          )}
        </InputMask>
      ) : (
        <input
          id={id}
          type={type}
          min={min}
          max={max}
          maxLength={maxLength}
          style={style}
          disabled={disabled}
          placeholder={placeholder}
          value={value}
          name={name}
          pattern={pattern}
          onChange={onChange}
          onBlur={onBlur}
          className={inputClass}
          autoComplete={autoComplete}
          required={required}
          onInput={onInput}
        />
      )}
    </>
  );
}

export default InputFormMask;
